import CarouselCardView from './messageTemplateCarouselCardView.html';
import { getDefaultImage } from '../MessageTemplateMediaUtils';
import { verifyActionsValueLength, HTTP_URL_REGEX } from '../models/MessageTemplateButtons';
import './messageTemplateCarouselCardView.scss';
class MessageTemplateCarouselCardController {
    initializeButtonOptions() {
        this.allButtonOptions = [
            { label: 'messageTemplateCarouselCard.button.options.quickReply', value: 'quick_reply' },
            { label: 'messageTemplateCarouselCard.button.options.url', value: 'url' },
            { label: 'messageTemplateCarouselCard.button.options.phoneNumber', value: 'phone_number' },
        ];
    }
    constructor($timeout, $element, $scope, $translate, AlertService) {
        'ngInject';
        this.$timeout = $timeout;
        this.carouselType = 'image';
        this.isMessageTemplateButtonsEnabled = true;
        this.cards = [
            {
                carouselType: 'image',
                mediaLink: '',
                text: '',
                buttons: [
                    {
                        type: 'quick_reply',
                        text: '',
                        url: '',
                        phone_number: '',
                    },
                ],
            },
        ];
        this.buttons = [];
        this.buttonOptions = [];
        this.allButtonOptions = [];
        this.isLoading = false;
        this.sandboxCards = [];
        this.sandboxButtons = [];
        this.sandboxCarouselType = 'image';
        this.sandboxBodyText = '';
        this.handleButtonTypeChange = event => {
            const newType = event.detail.value;
            const [, cardIndex, buttonIndex] = event.target.getAttribute('name').split('-').map(Number);
            if (this.cards[cardIndex]) {
                if (this.buttons[buttonIndex]) {
                    this.buttons[buttonIndex] = { type: newType };
                }
                this.syncCardButtons(buttonIndex, newType);
                this.updateButtonOptions();
                if (this?.$scope?.$evalAsync) {
                    this.$scope.$evalAsync();
                }
            }
        };
        this.handleCarouselTypeChange = event => {
            this.carouselType = event.detail.value;
        };
        this.handleMediaLinkChange = event => {
            const cardIndex = Number(event.target.getAttribute('name').split('-')[2]);
            const value = event.detail.value;
            if (typeof cardIndex === 'number' && this.cards[cardIndex]) {
                this.cards[cardIndex].mediaLink = value;
            }
        };
        this.handleButtonFieldChange = (event) => {
            const value = event.detail.value;
            const name = event.target.getAttribute('name');
            const [field, buttonIndex, cardIndex] = name.split('-');
            const cardIdx = Number(cardIndex);
            const btnIdx = Number(buttonIndex);
            if (typeof cardIdx === 'number' &&
                typeof btnIdx === 'number' &&
                this.cards[cardIdx]?.buttons?.[btnIdx]) {
                this.cards[cardIdx].buttons[btnIdx][field] = value;
                if (this?.$scope?.$evalAsync) {
                    this.$scope.$evalAsync();
                }
            }
        };
        this.$element = $element;
        this.$scope = $scope;
        this.$translate = $translate;
        this.AlertService = AlertService;
        this.ensureMinimumCards();
        this.initializeButtonOptions();
        this.updateButtonOptions();
        this.$scope = {
            ...this.$scope,
            editionEnabled: false,
            previewMode: false,
            bodyText: '',
            footerValue: '',
            selectedText: {
                finalText: '',
                initialText: '',
                textSelected: '',
            },
        };
    }
    $onInit() {
        this.defaultImage = [
            getDefaultImage('image'),
            getDefaultImage('video'),
        ];
        this.sandboxCards = JSON.parse(JSON.stringify(this.cards));
        this.sandboxButtons = JSON.parse(JSON.stringify(this.buttons));
        this.sandboxCarouselType = this.carouselType;
        this.sandboxBodyText = this.$scope.bodyText;
    }
    $onDestroy() {
        setTimeout(() => {
            const textareaElement = this.getTextareaElement();
            textareaElement?.removeEventListener('select', this.onSelectText.bind(this));
            textareaElement?.removeEventListener('mouseup', () => setTimeout(this.clearSelectedText.bind(this), 50));
            textareaElement?.removeEventListener('keydown', () => setTimeout(this.clearSelectedText.bind(this), 50));
        }, 1000);
    }
    enableEdition() {
        if (!this.onlyPreview) {
            this.$scope.editionEnabled = true;
            this.sandboxCards = JSON.parse(JSON.stringify(this.cards));
            this.sandboxButtons = JSON.parse(JSON.stringify(this.buttons));
            this.sandboxCarouselType = this.carouselType;
            this.sandboxBodyText = this.$scope.bodyText;
            this.updateButtonOptions();
        }
    }
    addCard(index) {
        if (!this.cards)
            this.cards = [];
        if (this.cards.length >= 10)
            return;
        this.isLoading = true;
        const cardButtons = this.buttons.map(btn => ({
            type: btn.type,
            text: '',
            url: '',
            phone_number: '',
        }));
        const newCard = {
            carouselType: this.carouselType,
            mediaLink: '',
            text: '',
            buttons: cardButtons.length > 0 ? cardButtons : [
                {
                    type: 'quick_reply',
                    text: '',
                    url: '',
                    phone_number: '',
                },
            ],
        };
        if (typeof index === 'number' && index >= 0 && index < this.cards.length) {
            const insertPosition = index + 1;
            this.cards = [
                ...this.cards.slice(0, insertPosition),
                newCard,
                ...this.cards.slice(insertPosition),
            ];
        }
        else {
            this.cards = [...this.cards, newCard];
        }
        this.updateButtonOptions();
        this.$timeout(() => {
            this.isLoading = false;
        });
    }
    removeCard(index) {
        if (!this.cards)
            return;
        if (this.cards.length <= 2)
            return;
        if (index >= 0 && index < this.cards.length) {
            this.isLoading = true;
            this.cards = this.cards.filter((_, i) => i !== index);
            this.updateButtonOptions();
            this.$timeout(() => {
                this.isLoading = false;
            });
        }
    }
    updateButtonOptions() {
        this.buttonOptions = [];
        for (let i = 0; i < 3; i++) {
            if (i >= this.buttons.length) {
                const usedTypes = this.buttons.slice(0, i).map(btn => btn.type);
                const availableOptions = this.allButtonOptions.filter(option => !usedTypes.includes(option.value));
                this.buttonOptions[i] = availableOptions;
            }
            else {
                const usedTypes = this.buttons
                    .slice(0, i)
                    .concat(this.buttons.slice(i + 1))
                    .map(btn => btn.type);
                const availableOptions = this.allButtonOptions.filter(option => !usedTypes.includes(option.value));
                this.buttonOptions[i] = availableOptions;
            }
        }
    }
    getButtonOptions(buttonIndex) {
        return this.buttonOptions[buttonIndex] || this.allButtonOptions;
    }
    delimiterLines(line) {
        if (line) {
            const newLineArray = [];
            const splitLimits = line.match(/.{1,20}/g);
            splitLimits.map(splited => {
                if (!/\s/g.test(splited)) {
                    const newLine = `${splited}<br>`;
                    newLineArray.push(newLine);
                }
                else {
                    newLineArray.push(splited);
                }
            });
            return newLineArray.join('');
        }
        else {
            return line;
        }
    }
    ensureMinimumCards() {
        if (!this.cards)
            this.cards = [];
        while (this.cards.length < 2) {
            this.cards.push({
                carouselType: this.carouselType,
                mediaLink: '',
                text: '',
                buttons: [
                    {
                        type: 'quick_reply',
                        text: '',
                        url: '',
                        phone_number: '',
                    },
                ],
            });
        }
        this.buttons = [
            {
                type: 'quick_reply',
            },
        ];
    }
    addButton(index) {
        if (this.cards[index].buttons.length >= 3)
            return;
        const buttonIndex = this.buttons.length;
        const availableOptions = this.buttonOptions[buttonIndex] || this.allButtonOptions;
        const type = availableOptions.length > 0 ? availableOptions[0].value : 'quick_reply';
        const btnType = { type };
        this.buttons = [...this.buttons, btnType];
        const btn = {
            type,
            text: '',
            url: '',
            phone_number: '',
        };
        this.syncButtonToAllCards(buttonIndex, btn);
        this.updateButtonOptions();
    }
    syncButtonToAllCards(buttonIndex, button) {
        this.cards.forEach(card => {
            if (!card.buttons) {
                card.buttons = [];
            }
            card.buttons[buttonIndex] = {
                type: button.type,
                text: button.text || '',
                url: button.url || '',
                phone_number: button.phone_number || '',
            };
        });
    }
    removeButton(cardIndex, buttonIndex) {
        if (this.buttons.length <= 1)
            return;
        this.buttons = this.buttons.filter((_, i) => i !== buttonIndex);
        this.cards = this.cards.map(card => ({
            ...card,
            buttons: card.buttons && card.buttons.length > buttonIndex
                ? card.buttons.filter((_, i) => i !== buttonIndex)
                : card.buttons,
        }));
        this.updateButtonOptions();
    }
    syncCardButtons(buttonIndex, newType) {
        if (!this.buttons) {
            this.buttons = [];
        }
        if (!this.buttons[buttonIndex]) {
            const existingButton = this.cards[0]?.buttons?.[buttonIndex];
            const type = newType ?? existingButton?.type ?? 'quick_reply';
            this.buttons[buttonIndex] = {
                type,
            };
        }
        if (newType) {
            this.buttons[buttonIndex].type = newType;
        }
        this.cards.forEach(card => {
            if (!card.buttons) {
                card.buttons = [];
            }
            if (!card.buttons[buttonIndex]) {
                card.buttons[buttonIndex] = {
                    type: this.buttons[buttonIndex].type,
                    text: '',
                    url: '',
                    phone_number: '',
                };
            }
            card.buttons[buttonIndex].type = this.buttons[buttonIndex].type;
            if (this.buttons[buttonIndex].type === 'quick_reply') {
                card.buttons[buttonIndex].url = '';
                card.buttons[buttonIndex].phone_number = '';
            }
            else if (this.buttons[buttonIndex].type === 'url') {
                card.buttons[buttonIndex].phone_number = '';
            }
            else if (this.buttons[buttonIndex].type === 'phone_number') {
                card.buttons[buttonIndex].url = '';
            }
        });
    }
    handleHeaderTypeChange(value, cardIndex) {
        if (typeof cardIndex === 'number' && this.cards[cardIndex]) {
            this.cards[cardIndex].carouselType = value;
        }
    }
    isHeaderValid(card) {
        const c = card || this.cards[0] || {
            carouselType: 'image',
            mediaLink: '',
            text: '',
            buttons: [],
        };
        const fmt = c.carouselType;
        if (fmt === 'image') {
            return !!(c.headerHandle ?? c.imageLink);
        }
        if (fmt === 'video') {
            return !!(c.headerHandle ?? c.videoLink);
        }
        return true;
    }
    buildContentObject() {
        return {
            carrouselType: this.carouselType,
            bodyText: this.$scope.bodyText,
            cards: this.cards,
            cardButtonVariables: this.getCardButtonVariables(),
            bodyTextVariables: this.getBodyTextVariables(),
            cardVariables: this.getCardVariables(),
        };
    }
    getBodyTextVariables() {
        if (!this.$scope.bodyText) {
            return null;
        }
        const variables = this.$scope.bodyText.match(/{{\d{1,10}}}/gm);
        return variables
            ? variables.sort((a, b) => {
                const numA = parseInt(a.replace(/[{}]/gm, ''));
                const numB = parseInt(b.replace(/[{}]/gm, ''));
                return numA - numB;
            })
            : null;
    }
    getCardVariables() {
        if (!this.cards?.length) {
            return null;
        }
        return this.cards.map(card => {
            const text = card?.text ? card.text : '';
            const variables = text.match(/{{\d{1,10}}}/gm);
            if (!variables)
                return [];
            return variables.sort((a, b) => {
                const numA = parseInt(a.replace(/[{}]/gm, ''), 10);
                const numB = parseInt(b.replace(/[{}]/gm, ''), 10);
                return numA - numB;
            });
        });
    }
    getCardButtonVariables() {
        if (!this.cards?.length) {
            return null;
        }
        return this.cards.map(card => {
            if (!card.buttons?.length) {
                return [];
            }
            return card.buttons.map(button => {
                if (button.type !== 'url' || !button.url) {
                    return [];
                }
                const variables = button.url.match(/{{\d{1,10}}}/gm);
                if (!variables)
                    return [];
                return variables.sort((a, b) => {
                    const numA = parseInt(a.replace(/[{}]/gm, ''), 10);
                    const numB = parseInt(b.replace(/[{}]/gm, ''), 10);
                    return numA - numB;
                });
            });
        });
    }
    closeEditionMode() {
        this.cards = JSON.parse(JSON.stringify(this.sandboxCards));
        this.buttons = JSON.parse(JSON.stringify(this.sandboxButtons));
        this.carouselType = this.sandboxCarouselType;
        this.$scope.bodyText = this.sandboxBodyText;
        this.$scope.editionEnabled = false;
        if (this?.$scope?.$evalAsync) {
            this.$scope.$evalAsync();
        }
    }
    async closeEditionConfirmation() {
        await this.AlertService.show({
            title: await this.$translate('attachment.closeNoSaveModal.title'),
            body: await this.$translate('attachment.closeNoSaveModal.text'),
            variant: 'warning',
            icon: 'attention',
            buttons: {
                cancel: await this.$translate('attachment.closeNoSaveModal.cancelButton'),
                confirm: await this.$translate('attachment.closeNoSaveModal.confirmButton'),
            },
            callback: {
                cancelButtonAction: () => { },
                confirmButtonAction: () => {
                    this.closeEditionMode();
                },
            },
        });
    }
    save() {
        if (this.verifyIfButtonsIsInvalid()) {
            throw new Error('Invalid buttons configuration');
        }
        const content = this.buildContentObject();
        this.sandboxCards = JSON.parse(JSON.stringify(this.cards));
        this.sandboxButtons = JSON.parse(JSON.stringify(this.buttons));
        this.sandboxCarouselType = this.carouselType;
        this.sandboxBodyText = this.$scope.bodyText;
        this.onConfirm({
            $event: {
                content,
            },
        });
        this.$scope.editionEnabled = false;
    }
    verifyIfButtonsIsInvalid() {
        if (!this.isMessageTemplateButtonsEnabled) {
            return false;
        }
        if (this.hasInvalidButtonsConfiguration()) {
            return true;
        }
        return this.cards.some(card => this.hasInvalidCard(card));
    }
    hasInvalidButtonsConfiguration() {
        if (!Array.isArray(this.buttons) || this.buttons.length < 1 || this.buttons.length > 3) {
            return true;
        }
        if (this.hasDuplicateButtonTypes()) {
            return true;
        }
        return this.buttons.some(btn => !btn?.type);
    }
    hasDuplicateButtonTypes() {
        const buttonTypes = this.buttons.map(btn => btn.type);
        const uniqueTypes = new Set(buttonTypes);
        return buttonTypes.length !== uniqueTypes.size;
    }
    hasInvalidCard(card) {
        if (!card.buttons || card.buttons.length === 0) {
            return true;
        }
        if (card.buttons.length !== this.buttons.length) {
            return true;
        }
        if (card.buttons.some((btn, i) => this.hasInvalidCardButton(btn, i))) {
            return true;
        }
        return this.hasDuplicateButtonTextsInCard(card);
    }
    hasInvalidCardButton(cardButton, buttonIndex) {
        const templateButton = this.buttons[buttonIndex];
        if (cardButton.type !== templateButton.type) {
            return true;
        }
        if (!cardButton.text || cardButton.text.trim().length === 0) {
            return true;
        }
        if (cardButton.type === 'url') {
            return this.hasInvalidUrlButton(cardButton);
        }
        if (cardButton.type === 'phone_number') {
            return this.hasInvalidPhoneButton(cardButton);
        }
        return false;
    }
    hasInvalidUrlButton(button) {
        if (!button.url || button.url.trim().length === 0) {
            return true;
        }
        if (verifyActionsValueLength(button.url, true)) {
            return true;
        }
        const urlWithoutVariables = button.url.replace(/\{\{1\}\}/g, 'x');
        return !new RegExp(HTTP_URL_REGEX).test(urlWithoutVariables);
    }
    hasInvalidPhoneButton(button) {
        if (!button.phone_number || button.phone_number.trim().length === 0) {
            return true;
        }
        return verifyActionsValueLength(button.phone_number, false);
    }
    hasDuplicateButtonTextsInCard(card) {
        const buttonTexts = card.buttons.map(btn => btn.text.trim().toLowerCase());
        const uniqueTexts = new Set(buttonTexts);
        return buttonTexts.length !== uniqueTexts.size;
    }
    addVariable() {
        const textareaElement = this.getTextareaElement();
        const variables = textareaElement.value.match(/{{\d{1,10}}}/gm);
        const lastVariable = variables
            ? variables
                .map(variable => parseInt(variable.replace(/[{}]/gm, '')))
                .sort((a, b) => a - b)[variables.length - 1]
            : 0;
        textareaElement.value += `{{${lastVariable + 1}}}`;
        textareaElement.focus();
        this.$scope.bodyText = textareaElement.value;
    }
    addVariableToCardText(cardIndex) {
        const textareaElement = this.getHeaderTextareaElement(cardIndex);
        const variables = textareaElement.value.match(/{{\d{1,10}}}/gm);
        const lastVariable = variables
            ? variables
                .map(variable => parseInt(variable.replace(/[{}]/gm, '')))
                .sort((a, b) => a - b)[variables.length - 1]
            : 0;
        textareaElement.value += `{{${lastVariable + 1}}}`;
        textareaElement.focus();
        this.cards[cardIndex].text = textareaElement.value;
    }
    getHeaderTextareaElement(cardIndex) {
        const element = this.$element[0];
        return element.querySelector(`textarea[name="card-title-${cardIndex}"]`);
    }
    applyBoldOnText() {
        this.addSymbolOnText('*');
    }
    applyItalicOnText() {
        this.addSymbolOnText('_');
    }
    applyStrikethroughOnText() {
        this.addSymbolOnText('~');
    }
    addSymbolOnText(symbol) {
        const textareaElement = this.getTextareaElement();
        if (this.$scope.selectedText.textSelected.length) {
            const { finalText, initialText, textSelected, } = this.$scope.selectedText;
            textareaElement.value =
                initialText + symbol + textSelected + symbol + finalText;
            this.clearSelectedTextScope();
            textareaElement.focus();
        }
        else {
            textareaElement.value += symbol + symbol;
            textareaElement.focus();
            const setInPosition = textareaElement.value.length - 1;
            textareaElement.setSelectionRange(setInPosition, setInPosition);
        }
        this.$scope.bodyText = textareaElement.value;
    }
    addListenerOnTextarea() {
        const textareaElement = this.getTextareaElement();
        textareaElement.onselect = this.onSelectText.bind(this);
        textareaElement.onmouseup = () => setTimeout(this.clearSelectedText.bind(this), 50);
        textareaElement.onkeydown = () => setTimeout(this.clearSelectedText.bind(this), 50);
    }
    onSelectText(event) {
        const target = event.target;
        const selectionStart = target.selectionStart;
        const selectionEnd = target.selectionEnd;
        const value = target.value;
        const textSelected = document.getSelection().toString();
        const initialText = value.substring(0, selectionStart);
        const finalText = value.substring(selectionEnd, value.length);
        this.$scope.selectedText = { textSelected, initialText, finalText };
    }
    getTextareaElement() {
        const element = this.$element[0];
        return element.querySelector('textarea[ng-model="$ctrl.$scope.bodyText"]');
    }
    clearSelectedText() {
        const textSelected = document.getSelection().toString();
        if (!textSelected.length && this.$scope.selectedText.textSelected.length) {
            this.clearSelectedTextScope();
        }
    }
    clearSelectedTextScope() {
        this.$scope.selectedText = {
            finalText: '',
            initialText: '',
            textSelected: '',
        };
    }
    hasCardVariable(card) {
        return !!(card?.title && card?.title?.indexOf('{{') !== -1);
    }
}
MessageTemplateCarouselCardController.$inject = ['$timeout', '$element', '$scope', '$translate', 'AlertService'];
export const MessageTemplateCarouselCardComponent = {
    template: CarouselCardView,
    controller: MessageTemplateCarouselCardController,
    controllerAs: '$ctrl',
    bindings: {
        onConfirm: '&',
        onlyPreview: '<?',
        card: '<?',
    },
};
